import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SubscriptionStatus } from 'src/app/enums/subscription.enum';
import { quotationGlobalState } from 'src/app/global-state/GlobalState';
import { SubscriptionItem, UserSubscription, UserSubscriptionResponse } from 'src/app/interfaces/subscription.interface';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import Helper from 'src/app/Util/helper';
import { StorageKeys } from 'src/app/Util/storage-keys';
@Component({
  selector: 'app-subscription-version-selection',
  templateUrl: './subscription-version-selection.component.html',
  styleUrls: ['./subscription-version-selection.component.sass']
})

export class SubscriptionVersionSelectionComponent implements OnChanges {

  @Input() groupedByVendorSubscriptions: UserSubscriptionResponse;
  @Output() activeSubscription = new EventEmitter<string>();

  isAnySubscription: boolean = false;
  subscriptionSelected: string | undefined = undefined;
  subscriptionItems: SubscriptionItem[] = [];

  constructor(private readonly localStorage: LocalStorageService) {}

  ngOnChanges(): void {

    this.clearSessionSubscription();

    if (this.groupedByVendorSubscriptions != null) {
    
      Object.keys(this.groupedByVendorSubscriptions)?.forEach((vendorName) => {
        let subs: UserSubscription[] = this.groupedByVendorSubscriptions[vendorName];
        
        subs?.forEach(subscription => {

          const subscriptionId = subscription.id;
          const isSelected = this.isSubscriptionSelected(subscriptionId);

          if (isSelected) {
            this.activeSubscription.emit(subscriptionId);
            quotationGlobalState.populateSubscriptionId(subscriptionId)
          }

          this.subscriptionItems.push(new SubscriptionItem( subscription.subscriptionName, subscription.id, vendorName, false, isSelected, subscription.status === SubscriptionStatus.AwaitingPlanSelection ));
        });

        this.isAnySubscription = true;
      });

    }
    
  }

  private isSubscriptionSelected(subscriptionId: string): boolean {
 
    const storedSubscriptionId = this.localStorage.getItemSessionStorage(StorageKeys.SubscriptionId);

    if (storedSubscriptionId) {
      return storedSubscriptionId === subscriptionId;
    }

    return this.subscriptionSelected === undefined || this.subscriptionSelected === subscriptionId;
 
  }
  
  clearSessionSubscription(): void {
    const storedSubscriptionId = this.localStorage.getItemSessionStorage(StorageKeys.SubscriptionId);

    if (storedSubscriptionId) {
      let subFound = false;

      Object.keys(this.groupedByVendorSubscriptions)?.forEach((vendorName) => {
        let subs: UserSubscription[] = this.groupedByVendorSubscriptions[vendorName];
        subs?.forEach(subscription => {
          if (subscription.id == storedSubscriptionId) subFound = true;
        });
      });
  
      if (subFound) return;

      this.localStorage.removeItemSessionStorage(StorageKeys.SubscriptionId);
    }
  }

  changeSubscription(e: Event): void {
    const selectElement = e.target as HTMLSelectElement;
    this.subscriptionSelected = selectElement.value;
    this.activeSubscription.emit(selectElement.value);
  }

}